import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "../src/component/Navbar/Navbar";
import "../src/styles/main.css";
import "./App.css";
import AddTask from "./Pages/AddTask/AddTask";
import EditTask from "./Pages/EditTask/EditTask";
import Main from "./Pages/Main/Main";


function App() {
  return (
    <BrowserRouter>
      <Header></Header>
      <Routes>
        <Route path="/" element={<Main></Main>}></Route>
        <Route path="/add" element={<AddTask></AddTask>}></Route>
        <Route path="/edit/:id" element={<EditTask></EditTask>}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
